import React from 'react';
import { ExternalLinkIcon, StyledExternalLink } from 'components/ExternalLink/style';

export const ExternalLink = ({ label, url, automationName }) => (
  <StyledExternalLink href={url} data-automation={automationName ? `${automationName}--link` : ''}>
    {label}<ExternalLinkIcon data-automation={automationName ? `${automationName}--link-icon` : ''} />
  </StyledExternalLink>
);
